import axios from '../request/http';


const account = {
    adminList(params) {
        return axios.get("/admin/admin-info/list", { params });
    },
    getReportUserList(params) {
        return axios.get("/admin/user/Report/getReportUserList", { params });
    },

    getReportCrowdList(params) {
        return axios.get("/admin/user/Report/getReportCrowdList", { params });
    },
    getReportInfo(params) {
        return axios.get("/admin/user/Report/getReportInfo", { params });
    },
    updateUserBanStatus(params) {
        return axios.get("/admin/user/Report/updateUserBanStatus", { params });
    },
    updateReportBanStatus(params) {
        return axios.get("/admin/user/Report/updateReportBanStatus", { params });
    },
    adminEnable(params) {
        return axios.get("/admin/admin-info/enable", { params });
    },
    adminEdit(data) {
        return axios.post("/admin/admin-info/edit", data);
    },
    adminJurisdiction(params) {
        return axios.get("/admin/roles/list", { params });
    },
    // app用户列表
    adminUserAppList(params) {
        return axios.get("/admin/user/list", { params });
    },
    // 推广记录
    adminFansList(params) {
        return axios.get("/admin/user/fans/list", { params });
    },
    // 修改上级
    updataBinding(params) {
        return axios.get("/admin/user/update/binding", { params });
    },
    // 私域平台用户修改上下级
    privacyBinding(params) {
        return axios.get("/admin/user/update/private/binding", { params });
    },
    // 修改用户积分
    updateIntegral(params) {
        return axios.get("/admin/user/update/integral", { params });
    },
    // 修改用户信息
    updateBaseInfo(data) {
        return axios.post("/admin/user/update/baseInfo", data);
    },
    // 余额变动
    updataBalance(params) {
        return axios.get("/admin/user/update/money", { params });
    },
    // 查看用户积分明细
    viewCreditDetail(params) {
        return axios.get("/admin/user/integral/list", { params });
    },
    balanceDetail(params) {
        return axios.get("/admin/user/cash/list", { params });
    },
    // 查看商户积分明细
    busBalanceDetail(params) {
        return axios.get("/admin/business/cash/list", { params });
    },
    //私域平台用户推广信息详情列表
    userFansList(params) {
        return axios.get("/admin/user/userFansInfo/list", { params });
    },

}

export default account;


// WEBPACK FOOTER //
// ./src/api/account.js